import { useEffect, useState } from 'react'
import PropTypes from "prop-types";

import axiosInstance from '../../../../variables/api/axiosInstance';
import { toast } from 'react-toastify';
import SDIModal from "../../../../components/ui/SDIModal";
import { useNavigate } from 'react-router-dom';

const AvenantDOrdre = (props) => {
    const [loading, setLoading] = useState(false);
    const [contrat, setContrat] = useState(props.contrat);
    const [modalAvenantOrdre, setModalAvenantOrdre] = useState(props.open);
    const [souscripteur, setSouscripteur] = useState("");
    const [errors, setErrors] = useState([{}]);
    const [professions, setProfessions] = useState([]);
    const [typePersonne, setTypePersonne] = useState("PHYSIQUE");
    const navigate = useNavigate();

    const formatPhoneDisplay = (value = "") => {
        const digits = `${value}`.replace(/\D/g, "").slice(0, 8);
        const parts = digits.match(/\d{1,2}/g);
        return parts ? parts.join(" ") : "";
    };

    useEffect(() => {
        axiosInstance
            .get(`/api/parametre/type/PROFESSION`)
            .then((res) => {
                const sorted = [...res.data].sort((a, b) =>
                    (a.libelleParametre || "").localeCompare(
                        b.libelleParametre || "",
                        "fr",
                        { sensitivity: "base" }
                    )
                );
                setProfessions(sorted);
            })
            .catch((err) => {
                console.log(err);
            });
        setSouscripteur(props?.contrat?.souscripteur);
        setModalAvenantOrdre(props.open);
        setContrat(props.contrat);
        setTypePersonne(props?.contrat?.souscripteur?.typePersonne || "PHYSIQUE");
    }, [props.open]);

    const handleAssureChange = (e) => {
        const { name, value } = e.target;
        if (name === "telephone") {
            const digitsOnly = value.replace(/\D/g, "").slice(0, 8);
            setSouscripteur((prev) => ({
                ...prev,
                telephone: digitsOnly,
                contact: digitsOnly ? [digitsOnly] : []
            }));
        } else {
            setSouscripteur((prev) => ({
                ...prev,
                [name]: value.toUpperCase()
            }));
        }
    };

    const handleAvenantOrdre = () => {
        if (loading) {
            return;
        }
        setLoading(true);
        const payload = {
            ...souscripteur,
            contact: Array.isArray(souscripteur?.contact)
                ? souscripteur.contact.map((phone) =>
                    typeof phone === "string" ? phone.replace(/\s+/g, "") : phone
                )
                : souscripteur?.contact,
        };
        axiosInstance.put(`/api/contrat/ordre-souscripteur`, JSON.stringify(payload))
            .then((res) => {
                toast("Informations mises à jour avec succès!");
                props.update(false);
                window.location.reload();
            }).catch((err) => {
                console.log(err);
                toast("Erreur lors de l'avenant");
            }).finally(() => setLoading(false));
    }

    const handleCancel = () => {
        setModalAvenantOrdre(false);
        props.update(false);
    };
    return (
        <SDIModal
            title="AVENANT D'ORDRE"
            confirmLoading={loading}
            centered
            open={modalAvenantOrdre}
            onOk={() => handleAvenantOrdre()}
            onCancel={() => handleCancel()}
            width={900}
            zIndex={1500}>
            <form id="addNewAddressForm" className="row g-12">
                <div className="col-12 col-md-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div class="col-xl-12">
                                <div class="card">
                                    <h5 class="card-header">Type de personne *</h5>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md mb-md-0 mb-5">
                                                <div
                                                    class="form-check custom-option custom-option-icon">
                                                    <label
                                                        class="form-check-label custom-option-content"
                                                        for="customRadioIcon2"
                                                    >
                                                        <span class="custom-option-body">
                                                            <i class="bx bx-user"></i>
                                                            <span class="custom-option-title">
                                                                {" "}
                                                                Physique{" "}
                                                            </span>
                                                            <small>
                                                                (Individuel, Particulier)
                                                            </small>
                                                        </span>
                                                        <input
                                                            name="customOptionRadioIcon"
                                                            class="form-check-input"
                                                            type="radio"
                                                            value=""
                                                            id="customRadioIcon2"
                                                            onChange={() => setTypePersonne("PHYSIQUE")}
                                                            checked={typePersonne === "PHYSIQUE"}
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-md">
                                                <div
                                                    class="form-check custom-option custom-option-icon">
                                                    <label
                                                        class="form-check-label custom-option-content"
                                                        for="customRadioIcon3"
                                                    >
                                                        <span class="custom-option-body">
                                                            <i class="bx bx-briefcase"></i>
                                                            <span class="custom-option-title">
                                                                {" "}
                                                                Morale{" "}
                                                            </span>
                                                            (Société, Entreprise)
                                                        </span>
                                                        <input
                                                            name="customOptionRadioIcon"
                                                            class="form-check-input"
                                                            type="radio"
                                                            value=""
                                                            id="customRadioIcon3"
                                                            onChange={() => setTypePersonne("MORALE")}
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="nom">
                                {typePersonne === "PHYSIQUE" ? "Nom" : "Dénomination sociale"} *
                            </label>
                            <input
                                type="text"
                                id="nom"
                                name="nom"
                                className={`form-control ${errors?.nom
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                placeholder={typePersonne === "PHYSIQUE" ? "Entrez le nom de l'assuré" : "Entrez la dénomination sociale"}
                                onChange={(e) => handleAssureChange(e)}
                                value={souscripteur?.nom}
                            />
                            {errors?.nom && (
                                <div className="invalid-feedback">
                                    {errors?.nom}
                                </div>
                            )}
                        </div>
                        {typePersonne === "PHYSIQUE" ? <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="prenom">
                                Prénom(s)
                            </label>
                            <input
                                type="text"
                                id="prenom"
                                name="prenom"
                                className={`form-control ${errors?.prenom
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                placeholder="Entrez le prénom de l'assuré"
                                onChange={(e) => handleAssureChange(e)}
                                value={souscripteur?.prenom}
                            />
                            {errors?.prenom && (
                                <div className="invalid-feedback">
                                    {errors?.prenom}
                                </div>
                            )}
                        </div> : null}
                        {typePersonne === "PHYSIQUE" ? <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="genre">
                                Sexe
                            </label>
                            <select
                                id="genre"
                                name="genre"
                                className={`form-control ${errors?.genre
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                onChange={(e) => handleAssureChange(e)}
                                value={souscripteur?.genre}
                            >
                                <option value="MASCULIN">MASCULIN</option>
                                <option value="FEMININ">FEMININ</option>
                            </select>
                            {errors?.genre && (
                                <div className="invalid-feedback">
                                    {errors?.genre}
                                </div>
                            )}
                        </div> : null}
                        {typePersonne === "PHYSIQUE" ? <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="profession">
                                Profession
                            </label>
                            <input
                                id="profession"
                                name="profession"
                                className={`form-control ${errors?.profession
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                onChange={(e) => handleAssureChange(e)}
                                value={souscripteur?.profession}
                            />
                            {errors?.profession && (
                                <div className="invalid-feedback">
                                    {errors?.profession}
                                </div>
                            )}
                        </div> : null}
                        <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="email">
                                Email
                            </label>
                            <input
                                type="text"
                                id="email"
                                name="email"
                                className={`form-control ${errors?.email
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                placeholder="Entrez l'adresse mail"
                                onChange={(e) => handleAssureChange(e)}
                                value={souscripteur?.email}
                            />
                            {errors?.email && (
                                <div className="invalid-feedback">
                                    {errors?.email}
                                </div>
                            )}
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="adresse">
                                {typePersonne === "PHYSIQUE" ? "Adresse de résidence" : "Siège social"} *
                            </label>
                            <input
                                type="text"
                                id="adresse"
                                name="adresse"
                                className={`form-control ${errors?.adresse
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                placeholder={typePersonne === "PHYSIQUE" ? "Entrez l'adresse de résidence" : "Entrez le siège social"}
                                onChange={(e) => handleAssureChange(e)}
                                value={souscripteur?.adresse}
                            />
                            {errors?.adresse && (
                                <div className="invalid-feedback">
                                    {errors?.adresse}
                                </div>
                            )}
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="phone">
                                Numéro de téléphone
                            </label>
                            <div className="input-group">
                                <span className="input-group-text">TG (+228)</span>
                                <input
                                    type="tel"
                                    id="telephone"
                                    name="telephone"
                                    className={`form-control phone-number-mask ${errors?.telephone
                                        ? "is-invalid"
                                        : ""
                                        }`}
                                    placeholder="00000000"
                                    onChange={(e) => handleAssureChange(e)}
                                    value={formatPhoneDisplay(
                                        souscripteur?.contact?.[0] ?? souscripteur?.telephone ?? ""
                                    )}
                                />
                                {errors?.telephone && (
                                    <div className="invalid-feedback">
                                        {errors?.telephone}
                                    </div>
                                )}
                            </div>
                        </div>
                        {typePersonne === "PHYSIQUE" ? <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="typePiece">
                                Type de pièce
                            </label>
                            <select
                                id="typePiece"
                                name="typePiece"
                                className={`form-control ${errors?.adresse
                                    ? "is-invalid" : ""}`}
                                data-allow-clear="true"
                                onChange={(e) => handleAssureChange(e)}
                                value={souscripteur?.typePiece}
                            >
                                <option value="CNI">CNI</option>
                                <option value="PASSEPORT">PASSEPORT</option>
                                <option value="ELECTEUR">CARTE D'ELECTEUR</option>
                            </select>
                            {errors?.typePiece && (
                                <div className="invalid-feedback">
                                    {errors?.typePiece}
                                </div>
                            )}
                        </div> : null}
                        {typePersonne === "PHYSIQUE" ? <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="numIdentite">
                                Numéro de la pièce d'identité
                            </label>
                            <input
                                type="text"
                                id="numIdentite"
                                name="numIdentite"
                                className={`form-control ${errors?.numIdentite ? "is-invalid" : ""}`}
                                placeholder="Entrez le numéro de la pièce"
                                onChange={(e) => handleAssureChange(e)}
                                value={souscripteur?.numIdentite}
                            />
                            {errors?.numIdentite && (
                                <div className="invalid-feedback">
                                    {errors?.numIdentite}
                                </div>
                            )}
                        </div> : null}
                        {typePersonne === "PHYSIQUE" ? <div className="col-12 col-md-6">
                            <label className="form-label" htmlFor="dateDelivrance">
                                Date de délivrance
                            </label>
                            <div className="col-md-12">
                                <input
                                    className={`form-control ${errors?.dateDelivrance ? "is-invalid" : ""}`}
                                    type="date"
                                    id="dateDelivrance"
                                    name="dateDelivrance"
                                    onChange={(e) => handleAssureChange(e)}
                                    value={souscripteur?.dateDelivrance}
                                />
                                {errors?.dateDelivrance && (
                                    <div className="invalid-feedback">
                                        {errors?.dateDelivrance}
                                    </div>
                                )}
                            </div>
                        </div> : null}
                        {typePersonne === "PHYSIQUE" ? null : <div className="col-sm-6">
                            <label
                                className="form-label"
                                htmlFor="numeroRegistreCommerce"
                            >
                                Numéro de régistre de commerce *
                            </label>
                            <input
                                type="text"
                                id="numeroRegistreCommerce"
                                className={`form-control ${errors?.numeroRegistreCommerce ? "is-invalid" : ""}`}
                                placeholder="Entrez le numéro de registre de commerce"
                                name="numeroRegistreCommerce"
                                value={souscripteur.numeroRegistreCommerce}
                                onChange={handleAssureChange}
                            />
                            {errors?.numeroRegistreCommerce && (
                                <div className="invalid-feedback">
                                    {errors?.numeroRegistreCommerce}
                                </div>)}
                        </div>}
                        {typePersonne === "PHYSIQUE" ? null : <div className="col-sm-6">
                            <label className="form-label" htmlFor="nif">
                                Numéro d'identification fiscale *
                            </label>
                            <input
                                type="text"
                                id="nif"
                                className={`form-control ${errors?.nif ? "is-invalid" : ""}`}
                                placeholder="Entrez le NIF"
                                name="nif"
                                value={souscripteur.nif}
                                onChange={handleAssureChange}
                            />
                            {errors?.nif && (
                                <div className="invalid-feedback">
                                    {errors?.nif}
                                </div>)}
                        </div>}
                    </div>
                </div>
            </form>
        </SDIModal>
    )
}
AvenantDOrdre.propTypes = {
    open: PropTypes.bool,
    update: PropTypes.func,
    contrat: PropTypes.object
}

export default AvenantDOrdre
